import React, { Component } from 'react'
import GraphFull from './GraphFull'
import NumberCounter from './NumberCounter'
import { AnnotationCallout } from 'react-annotation'

const initialValues = [38, 33, 20, 12, 8]

let width = window.innerWidth
let xTopArrow = 260
let yTopArrow = 40
let xBottomArrow = 260
let yBottomArrow = 90

if (width < 550 && width > 384) {
  yBottomArrow = 110
} else if (width < 385) {
  yTopArrow = 50
  yBottomArrow = 130
}

export default class Calculator extends Component {
  constructor(props) {
    super(props)
    this.state = {
      values: [38, 33, 20, 12, 8],
      taxes: 52107181855,
      pct: [4.45175237, 19.46085515, 29.68911209, 35.61142703, 10.79]
    }
  }

  trackCalcClicks(clickedText) {
    window.dataLayer = window.dataLayer || []
    window.dataLayer.push({
      event: 'Interactions',
      eventAction: 'click',
      eventLabel: clickedText
    })
  }

  calcTaxes(val) {
    let taxes =
      61044281.7 * val[0] +
      307287975 * val[1] +
      773507981 * val[2] +
      1546342587 * val[3] +
      702590662 * val[4]
    this.setState({
      taxes: taxes
    })
    let p = [
      (100 / taxes) * 702590662 * val[4],
      (100 / taxes) * 1546342587 * val[3],
      (100 / taxes) * 773507981 * val[2],
      (100 / taxes) * 307287975 * val[1],
      (100 / taxes) * 61044281.7 * val[0]
    ]
    this.setState({
      pct: p
    })
  }

  minusClick(cls) {
    let p = { ...this.state.values }
    if (p[cls] > 0) {
      p[cls] = p[cls] - 1
      this.setState({
        values: p
      })
    }
    this.calcTaxes(p)
  }

  plusClick(cls) {
    let p = { ...this.state.values }
    if (p[cls] < 99) {
      p[cls] = p[cls] + 1
      this.setState({
        values: p
      })
    }
    this.calcTaxes(p)
  }

  reset(cls) {
    let p = { ...this.state.values }
    p[cls] = initialValues[cls]

    this.setState({
      values: p
    })
    this.calcTaxes(p)
  }

  render() {
    return (
      <div style={{ textAlign: 'center' }}>
        <div>
          {/* <AnimatedNumber
            component='text'
            value={this.state.taxes}
            style={{
              transition: '0.8s ease-out',
              fontSize: 48,
              transitionProperty: 'background-color, color, opacity'
            }}
            frameStyle={perc =>
              perc === 100 ? {} : { backgroundColor: '#ffeb3b' }
            }
            duration={300}
            stepPrecision={2}
            formatValue={n => addCommas(n / 1000000) + ' Mio. Fr'}
          /> */}
          <NumberCounter
            title={'Berechnen Sie ihre Steuereinnahmen:'}
            diff={1}
            start_value={52107181855}
            value={this.state.taxes}
          />
        </div>
        <br />
        <br />
        <div className='calculator' style={{ textAlign: 'center' }}>
          <div style={{ width: '100%', position: 'absolute' }}>
            <GraphFull pct={this.state.pct} />
            <svg
              viewBox='0,0,600,600'
              style={{ position: 'absolute', left: '0px', top: '0px' }}
            >
              <AnnotationCallout
                x={70}
                y={35}
                color={'#000000'}
                className='show-bg'
                note={{
                  title: 'Ø - Steuersatz verändern.',
                  label:
                    'Mit Pfeiltasten erhöhen<n>und senken. Auf den Steuersatz <n>tippen um auf Ausgangswert <n>zurückzusetzen.',
                  lineType: null,
                  bgPadding: { top: 0, left: 0, right: 0, bottom: 0 },
                  padding: 5,
                  titleColor: '#000000',
                  wrapSplitter: '<n>',
                  orientation: 'leftRight',
                  align: 'left'
                }}
              />
              <image
                className='topArrow'
                x={xTopArrow}
                y={yTopArrow}
                xlinkHref='images/arrow-top.svg'
              />
              <image
                className='bottomArrow'
                x={xBottomArrow}
                y={yBottomArrow}
                xlinkHref='images/arrow-bottom.svg'
              />
            </svg>
          </div>
          <div className='ui grid' style={{ paddingLeft: '7px' }}>
            {/* <Swipeable
              className='line'
              {...{
                onSwipedLeft: () => this.minusClick('4'),
                onSwipedRight: () => this.plusClick('4'),
                preventDefaultTouchmoveEvent: true,
                trackMouse: true
              }}
            > */}
            <div className='row calc-top-row' />
            <div className='row calc-row'>
              <div className='left aligned six wide column' />
              <div className='four wide column'>
                <div className='operateCalc'>
                  <div className='navTop'>
                    <i
                      className='chevron up icon'
                      onClick={() => {
                        this.plusClick('0')
                        this.trackCalcClicks('Top 0.01: +')
                      }}
                    />
                  </div>
                  <div className='value'>
                    <span
                      className='button button-round noselect'
                      onClick={() => this.reset('0')}
                    >
                      {this.state.values[0]}%
                    </span>
                  </div>
                  <div className='navBottom'>
                    <i
                      className='chevron down icon'
                      onClick={() => {
                        this.minusClick('0')
                        this.trackCalcClicks('Top 0.01: -')
                      }}
                    />
                  </div>
                </div>
              </div>
              <div className='right aligned six wide column' />
            </div>
            {/* </Swipeable> */}
            {/* <Swipeable
              className='line'
              {...{
                onSwipedLeft: () => this.minusClick('3'),
                onSwipedRight: () => this.plusClick('3'),
                preventDefaultTouchmoveEvent: true,
                trackMouse: true
              }}
            > */}
            <div className='row calc-row'>
              <div className='left aligned six wide column' />
              <div className='four wide column'>
                <div className='operateCalc'>
                  <div className='navTop'>
                    <i
                      className='chevron up icon'
                      onClick={() => {
                        this.plusClick('1')
                        this.trackCalcClicks('Top 1: +')
                      }}
                    />
                  </div>
                  <div className='value'>
                    <span
                      className='button button-round noselect'
                      onClick={() => this.reset('1')}
                    >
                      {this.state.values[1]}%
                    </span>
                  </div>
                  <div className='navBottom'>
                    <i
                      className='chevron down icon'
                      onClick={() => {
                        this.minusClick('1')
                        this.trackCalcClicks('Top 1: -')
                      }}
                    />
                  </div>
                </div>
              </div>
              <div className='right aligned six wide column' />
            </div>
            {/* </Swipeable>
            <Swipeable
              className='line'
              {...{
                onSwipedLeft: () => this.minusClick('2'),
                onSwipedRight: () => this.plusClick('2'),
                preventDefaultTouchmoveEvent: true,
                trackMouse: true
              }}
            > */}
            <div className='row calc-row'>
              <div className='left aligned six wide column' />
              <div className='four wide column'>
                <div className='operateCalc'>
                  <div className='navTop'>
                    <i
                      className='chevron up icon'
                      onClick={() => {
                        this.plusClick('2')
                        this.trackCalcClicks('Top 10: +')
                      }}
                    />
                  </div>
                  <div className='value'>
                    <span
                      className='button button-round noselect'
                      onClick={() => this.reset('2')}
                    >
                      {this.state.values[2]}%
                    </span>
                  </div>
                  <div className='navBottom'>
                    <i
                      className='chevron down icon'
                      onClick={() => {
                        this.minusClick('2')
                        this.trackCalcClicks('Top 10: -')
                      }}
                    />
                  </div>
                </div>
              </div>
              <div className='right aligned six wide column' />
            </div>
            {/* </Swipeable>
            <Swipeable
              className='line'
              {...{
                onSwipedLeft: () => this.minusClick('1'),
                onSwipedRight: () => this.plusClick('1'),
                preventDefaultTouchmoveEvent: true,
                trackMouse: true
              }}
            > */}
            <div className='row calc-row'>
              <div className='left aligned six wide column' />
              <div className='four wide column'>
                <div className='operateCalc'>
                  <div className='navTop'>
                    <i
                      className='chevron up icon'
                      onClick={() => {
                        this.plusClick('3')
                        this.trackCalcClicks('Top 50: +')
                      }}
                    />
                  </div>
                  <div className='value'>
                    <span
                      className='button button-round noselect'
                      onClick={() => this.reset('3')}
                    >
                      {this.state.values[3]}%
                    </span>
                  </div>
                  <div className='navBottom'>
                    <i
                      className='chevron down icon'
                      onClick={() => {
                        this.minusClick('3')
                        this.trackCalcClicks('Top 50: -')
                      }}
                    />
                  </div>
                </div>
              </div>
              <div className='right aligned six wide column' />
            </div>
            {/* </Swipeable>
            <Swipeable
              className='line'
              {...{
                onSwipedLeft: () => this.minusClick('0'),
                onSwipedRight: () => this.plusClick('0'),
                preventDefaultTouchmoveEvent: true,
                trackMouse: true
              }}
            > */}
            <div className='row calc-row'>
              <div className='left aligned six wide column' />
              <div className='four wide column'>
                <div className='operateCalc'>
                  <div className='navTop'>
                    <i
                      className='chevron up icon'
                      onClick={() => {
                        this.plusClick('4')
                        this.trackCalcClicks('Bottom 50: +')
                      }}
                    />
                  </div>
                  <div className='value'>
                    <span
                      className='button button-round noselect'
                      onClick={() => this.reset('4')}
                    >
                      {this.state.values[4]}%
                    </span>
                  </div>
                  <div className='navBottom'>
                    <i
                      className='chevron down icon'
                      onClick={() => {
                        this.minusClick('4')
                        this.trackCalcClicks('Bottom 50: -')
                      }}
                    />
                  </div>
                </div>
              </div>
              <div className='right aligned six wide column' />
            </div>
            {/* </Swipeable> */}
          </div>
        </div>
      </div>
    )
  }
}
